import { All, Query } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import {
  dataRequested,
  updateUi,
  dataLoaded,
  receiveResultsFailure,
} from "../common/actions";
import BankFind from "../components/BankFind/BankFind";
import { initialAppState } from "../common/reducers/appState";

export function mapStateToProps({ appState, ui }: All) {
  return {
    appState: appState.bankFind as Query,
    dataLoaded: ui.dataLoaded,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    onStartRequest: () => {
      dispatch(dataRequested());
    },
    updateUi: (uiField: string, uiValue: string | undefined) => {
      dispatch(updateUi(uiField, uiValue));
    },
    updateFilter: (field: string, value: string | undefined) => {
      dispatch(actions.updateFilter(field, value));
    },
    resetState: () => {
      dispatch(actions.resetState(initialAppState.bankFind));
    },
    onResultSuccess: () => {
      dispatch(dataLoaded());
    },
    onResultFailure: (error: any) => dispatch(receiveResultsFailure(error)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BankFind);
